import { LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class UserNameLookup extends LookupBase {

    public userId: string = "";

    public userName: string = "";

    public userFullName: string = "";

    public userIntegerId: number = 0;

    // Client only properties / methods
}